import { render, staticRenderFns } from "./directory-selection.vue?vue&type=template&id=06704c64&scoped=true&"
import script from "./directory-selection.vue?vue&type=script&lang=js&"
export * from "./directory-selection.vue?vue&type=script&lang=js&"
import style0 from "./directory-selection.vue?vue&type=style&index=0&id=06704c64&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06704c64",
  null
  
)

export default component.exports